export type BadgeTone = 'teal' | 'neutral' | 'danger';

const TONE_CLASSES: Record<BadgeTone, string> = {
  teal: 'text-brand-teal bg-brand-teal/10 border-brand-teal/25',
  neutral: 'text-white/35 bg-white/4 border-white/10',
  danger: 'text-brand-danger bg-brand-danger/10 border-brand-danger/25',
};

export const Badge = ({
  tone,
  dot = false,
  pulse = false,
  children,
}: {
  tone: BadgeTone;
  dot?: boolean;
  pulse?: boolean;
  children: React.ReactNode;
}) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[0.7rem] font-semibold tracking-[0.04em] ${TONE_CLASSES[tone]}`}
  >
    {dot && (
      <span
        className={`h-[5px] w-[5px] rounded-full bg-current ${pulse ? 'animate-pulse-dot' : ''}`}
        style={pulse ? { boxShadow: '0 0 4px currentColor' } : undefined}
      />
    )}
    {children}
  </span>
);
